export const ANNOUNCEMENT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
};

export const DISPLAY_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  SCHEDULED: 2,
  EXPIRED: 3,
};

export const TAB_FILTER = {
  ALL: 0,
  ACTIVE: 1,
  SCHEDULED: 2,
  EXPIRED: 3,
};

export const TAB_DATA = [
  { label: 'Active', value: TAB_FILTER.ACTIVE },
  { label: 'Scheduled', value: TAB_FILTER.SCHEDULED },
  { label: 'Expired', value: TAB_FILTER.EXPIRED },
  { label: 'All', value: TAB_FILTER.ALL },
];

export const DISPLAY_STATUS_LABEL = {
  [DISPLAY_STATUS.INACTIVE]: 'Inactive',
  [DISPLAY_STATUS.ACTIVE]: 'Active',
  [DISPLAY_STATUS.SCHEDULED]: 'Scheduled',
  [DISPLAY_STATUS.EXPIRED]: 'Expired',
};

export const STATUS_OPTIONS = [
  { label: 'Inactive', value: ANNOUNCEMENT_STATUS.INACTIVE },
  { label: 'Active', value: ANNOUNCEMENT_STATUS.ACTIVE },
];

export const CONTENT_MAX_LENGTH = 2000;

export const defaultAnnouncementForm = {
  title: '',
  content: '',
  startDate: null,
  endDate: null,
  status: ANNOUNCEMENT_STATUS.ACTIVE,
};
